export const conversationStarters: string[] = [
  'Analyze my portfolio performance',
  'What are my top performing assets?',
  'How is my diversification?',
  'Suggest some rebalancing moves',
  'Compare my portfolio to the S&P 500',
  'What is my exposure to the tech sector?',
  'Do I have any overlapping ETFs?',
  'Identify high-fee funds in my portfolio',
  'How would a market crash affect me?',
  'What are the risks in my portfolio?',
  'Show me my asset allocation pie chart',
  'Calculate my Sharpe ratio',
  'Am I too concentrated in any stock?',
  'What is my projected annual income?',
  'How much dividends will I receive this year?',
  'Analyze the volatility of my holdings',
  'Suggest a more aggressive allocation',
  'Suggest a more conservative allocation',
  'What stocks should I consider selling?',
  'What sectors am I missing?',
  'How has my portfolio done year-to-date?',
  "Explain my portfolio's beta",
  'What is my maximum drawdown?',
  'Review my investment fees',
  'Optimize my portfolio for tax efficiency',
  'Forecast my portfolio value in 10 years',
  'Check for correlation between my assets',
  'How does inflation impact my returns?',
  'Should I add international exposure?',
  'Evaluate my risk-adjusted returns',
];

export const getRandomConversationStarters = (count: number = 4): string[] => {
  const shuffled = [...conversationStarters].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

export const getAiPromptForQuestion = (question: string): string | null => {
  // For simple string starters, the question is the prompt
  return conversationStarters.includes(question) ? question : null;
};
